import  React from 'react';
import { CubeEngine } from '../graphics/cubeEngine';
import { RadioButtonGroup } from '../components/RadioButtonGroup';
import { Layout, Slider, Switch } from "antd";
import "antd/dist/antd.css";
import './cubeco2.css';
import Sider from 'antd/lib/layout/Sider';
import { Content } from 'antd/lib/layout/layout';

interface IProps { }
interface IPropsState { }

export class CubeCo2 extends React.Component<IProps, IPropsState>  {

    graphicsEngine: any;

    StartCube = (() => {
        var framesPerSecond = 25;      
        var xSkew = 5;
        var ySkew = 5;
        this.graphicsEngine = new CubeEngine('cubeCo2Canvas', framesPerSecond , xSkew, ySkew);
        this.graphicsEngine.StartEngine();
    })

    componentDidMount = ((): any => {this.StartCube();})

    SetCo2 = ((val:number) => {this.graphicsEngine.SetCo2Selection(val === 0);})

    SetShapeToSphere = ((val:number) => {this.graphicsEngine.SetDisplayShapeAsSphere(val === 1);})

    SetClustered = ((val :number) => {this.graphicsEngine.SetClustered(val === 0);})

    SetframesPerSecond = ((val :number) => {this.graphicsEngine.SetframesPerSecond(val);})

    SetXskew = ((val :number) => {this.graphicsEngine.SetXskew(val);})

    SetYskew = ((val :number) => {this.graphicsEngine.SetYskew(val);})

    SetRun = ((val :boolean) => {this.graphicsEngine.SetRun(val);})

    render() {
        return(
            <Layout hasSider className='page-layout'>
                <Sider className='sidebar' >
                    <Switch 
                        checkedChildren='Start' 
                        unCheckedChildren='Pause' 
                        defaultChecked 
                        onChange={(val) => { this.SetRun(val) }}
                        className='switch-button'
                    />
                    <div className='radio-group'>
                        <RadioButtonGroup 
                            identifiedBy={'radioShape'}
                            title={'Shape'}
                            radioButtons={
                                [{label:'Cube', checked: true},
                                {label:'Sphere', checked: false}]
                                } 
                            onChanged={(val: number) => {this.SetShapeToSphere(val)}}
                        />
                    </div>                    
                    <div className='radio-group'>
                        <RadioButtonGroup 
                            identifiedBy={'radioCo2'}
                            title={'CO2'}
                            radioButtons={
                                [{label:'Total CO2', checked: true},
                                {label:'Man-made CO2', checked: false}]
                                } 
                            onChanged={(val: number) => { this.SetCo2(val)}}
                        />
                    </div>
                    <div className='radio-group'>
                        <RadioButtonGroup 
                            identifiedBy={'radioClustered'}
                            title={'Particles'}
                            radioButtons={
                                [{label:'Clustered', checked: false},
                                {label:'Distributed', checked: true}]
                                } 
                            onChanged={(val: any) => { this.SetClustered(val) }}
                        />
                    </div>                
                    <div className='slider'>Frames per second</div>
                    <div className='slider-inner'>
                        <Slider 
                            defaultValue={25} 
                            min={1}
                            max={100}
                            step={1}
                            onChange={(e: any) => {	 this.SetframesPerSecond(e);}} 
                            disabled={false}
                            tooltipVisible={false}
                            tooltipPlacement='bottom'/>
                    </div>
                    <div className='slider'>X rotation</div>
                    <div className='slider-inner'>
                        <Slider 
                            defaultValue={0} 
                            min={-190}
                            max={170}
                            step={1}
                            onChange={(e: any) => {	this.SetXskew(e); }} 
                            disabled={false}
                            tooltipVisible={false}
                            tooltipPlacement='bottom'/>
                    </div>
                    <div className='slider'>Y rotation</div>
                    <div className='slider-inner'>
                        <Slider 
                            defaultValue={0} 
                            min={-190}
                            max={170}
                            step={1}
                            onChange={(e: any) => {	this.SetYskew(e); }} 
                            disabled={false}
                            tooltipVisible={false}
                            tooltipPlacement='bottom'/>
                    </div>
                </Sider>
                <Layout>
                    <Content>
                        <canvas id="cubeCo2Canvas" />
                    </Content>
                </Layout>
            </Layout>
        );
    }
};